export class AddProductGroupingInput {
  orderId: number;
  orderItemIdList: number[];
}